import styled from "styled-components";
import { motion } from "framer-motion";

export const C_Container = styled(motion.div)`
	display: grid;

	grid-auto-rows: 250px;
	gap: 20px;
`;

export const coursesVariants = {
	hidden: {},

	visible: {
		transition: {
			delayChildren: 0.12,
			staggerChildren: 0.1,
		},
	},
	exit: {},
};
